<!--
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
-->
<template>
  <van-dialog
    v-model="visible"
    :title="$t('c329ccef3a')"
    class="switchAccountDialog"
    :close-on-click-overlay="false"
    :show-confirm-button="false"
    @closed="handleClose"
  >
    <div class="switch-content">
      「{{ companyName }}」{{ $t('e370f9afb1')
      }}<img class="switch-content-logo" :src="userLogo" />
      <span class="switch-content-name">{{ userName }}</span
      >{{ $t('410cf42585') }}
    </div>
    <div class="switch-footer">
      <div class="switch-footer-btn" type="primary" @click="handleClick">
        {{ $t('062d48aece') }}
      </div>
      <div class="switch-footer-time">{{ times }}s{{ $t('95a105d412') }}</div>
    </div>
  </van-dialog>
</template>
<script>
import { Account } from '@store/modules/user/constants'
import {
  CLOSEDIALOG,
  VISABEL,
  DIALOGDATA,
} from '@store/modules/switchAccount/constants'
import { Dialog } from 'vant'
import Vue, { ref, computed, getCurrentInstance, watch } from 'vue'
import useStore from '@hooks/useStore'
import { useSwitchAccount } from '../hooks/useSwitchAccount'
import useReport from '../hooks/useReport'
Vue.use(Dialog)
export default {
  setup() {
    let timer = null
    const vm = getCurrentInstance()
    const { switchAccount } = useSwitchAccount()
    const { report } = useReport()
    const times = ref(5)
    const store = useStore(vm)
    const visible = computed(() => store.state?.switchAccount[VISABEL])
    const companyName = computed(
      () => store.state?.switchAccount[DIALOGDATA].companyName
    )
    const openUrl = computed(
      () => store.state?.switchAccount[DIALOGDATA].openUrl
    )
    const companyId = computed(
      () => store.state?.switchAccount[DIALOGDATA].companyId
    )
    const account = computed(() => store.state?.user[Account]) // 用户信息
    const userName = computed(() => account.value?.nickname)
    const userLogo = computed(() => account.value?.pic)
    const handleSwitchAccount = () => {
      clearInterval(timer)
      timer = null
      switchAccount(openUrl, companyId)
      vm.proxy.$store.commit(CLOSEDIALOG)
    }
    const handleClick = () => {
      report({
        operation: 'click',
        company_id: companyId.value,
      })
      handleSwitchAccount()
    }
    const handleClose = () => {
      report({
        operation: 'close',
        company_id: companyId.value,
      })
      vm.proxy.$store.commit(CLOSEDIALOG)
    }
    const initTimer = () => {
      timer = setInterval(() => {
        times.value--
        if (times.value === 0) {
          handleSwitchAccount()
        }
      }, 1000)
    }
    watch(visible, val => {
      if (!val) return
      report({
        operation: 'show',
        company_id: companyId.value,
      })
      initTimer()
    })
    return {
      visible,
      userName,
      userLogo,
      times,
      companyName,
      handleClick,
      handleClose,
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@assets/constant.scss';
.switchAccountDialog {
  width: 686px;
  .switch-content {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 32px;
    color: #333333;
    letter-spacing: 0;
    line-height: 48px;
    padding: 16px 32px 0;
    .switch-content-logo {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;
      margin: 0 20px 0 12px;
    }
    .switch-content-name {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 32px;
      color: #666666;
      letter-spacing: 0;
      line-height: 48px;
    }
  }
  .switch-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 42px;
    padding-bottom: 42px;
    .switch-footer-btn {
      width: 540px;
      height: 94px;
      background: #417ff9;
      border-radius: 8px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 32px;
      color: #ffffff;
      line-height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .switch-footer-time {
      margin-top: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 32px;
      color: rgba(0, 0, 0, 0.4);
      letter-spacing: 0;
      text-align: center;
      line-height: 48px;
    }
  }
}
</style>

<style lang="scss">
.register-body {
  .switchAccountDialog .van-dialog__header {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 36px;
    color: #3c414b;
    letter-spacing: 0;
    text-align: center;
    line-height: 54px;
    padding-top: 48px;
  }
}
</style>
